import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Header from '../../molecules/Header/Header';
import Footer from '../../molecules/Footer/Footer';
import Game from '../../pages/Game/Game';
import Page from '../../pages/Page/Page';
import RoutesTransition from './Routes.styled';
import { onRouteChange } from '../../../state-actions/onRouteChange';
import { ModalWIP } from '../../../API/content';
import Modal from '../../molecules/Modal/Modal';

const mapDispatchToProps = (dispatch) => ({
  onRouteChange: (route) => dispatch(onRouteChange(route)),
});

const mapStateToProps = (state) => ({
  showWarning: state.showWarning,
});

class Routes extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.props.onRouteChange(true);
    }
  }

  render() {
    const { location, showWarning } = this.props;
    const locationPath = location.pathname;

    return (
      <TransitionGroup className="routes-wrapper">
        <CSSTransition key={locationPath} classNames="fade" timeout={250}>
          <RoutesTransition>
            <Header />
            {process.env.NODE_ENV !== 'development' && showWarning && (
              <Modal
                title={ModalWIP.title}
                content={ModalWIP.content}
                btnText={ModalWIP.btnText}
              />
            )}
            <Switch location={location}>
              <Route exact path="/" component={() => <Game />} />
              <Route exact path="/about" component={() => <Page />} />
              <Route component={() => <Game />} />
            </Switch>
            <Footer />
          </RoutesTransition>
        </CSSTransition>
      </TransitionGroup>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Routes);

Routes.propTypes = {
  location: PropTypes.objectOf(PropTypes.string).isRequired,
  showWarning: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisms/Routes/Routes.js